import { JsonObject, JsonProperty } from 'json2typescript';
import { SearchParams } from '../searchParams';

@JsonObject('TimesheetSearchParams')
export class TimesheetSearchParams extends SearchParams {
    @JsonProperty('end_date_range_range_before', String, true)
    endAfter = null;

    @JsonProperty('end_date_range_range_after', String, true)
    endBefore = null;
}


@JsonObject('TimesheetEntrySearchParams')
export class TimesheetEntrySearchParams extends SearchParams {
    @JsonProperty('lawyer', [Number], true)
    lawyer = [];

    @JsonProperty('timesheet', [Number], true)
    timesheet = [];

    @JsonProperty('service', [Number], true)
    service = [];

    @JsonProperty('case', [Number], true)
    case = [];

    @JsonProperty('date_after', String, true)
    dateAfter = null;

    @JsonProperty('date_before', String, true)
    dateBefore = null;

    @JsonProperty('state', [Number], true)
    state = [];
}

@JsonObject('TimesheetExpenseSearchParams')
export class TimesheetExpenseSearchParams extends SearchParams {
    @JsonProperty('expense_type', [Number], true)
    expense_type = null;

    @JsonProperty('timesheet', Number, true)
    timesheet = null;

    @JsonProperty('case', [Number], true)
    case = [];

    @JsonProperty('date_after', String, true)
    dateAfter = null;

    @JsonProperty('date_before', String, true)
    dateBefore = null;
}


